import styled from 'styled-components'

export const PickupHeaderWrapper = styled.div`
  .title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 40px;
  }
  .button-link {
    text-decoration: none;
  }

  .filter-wrapper {
    position: sticky;
    top: 0;
    z-index: 1;
    padding: 25px 40px;
    background: ${props => props.theme.colors.alabaster};
  }

  .title {
    color: ${props => props.theme.colors.primary};
    margin: 0;
    font-size: ${props => props.theme.fontSizes.section.sectionTitle};
  }

  .filter-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    z-index: 2;

    .select-field {
      border-radius: 3px;
    }
  }

  .filter-button > div {
    height: 50px;
    line-height: 50px;
  }

  .filter-left {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .react-tags__search {
      > div {
        &:nth-of-type(1) {
          background-color: initial;
        }

        &:nth-of-type(2) {
          width: 280px;
        }
      }
    }

    .searchBoxButton {
      left: 280px;
      position: absolute;
    }
  }

  .show-only-booked {
    width: 100%;
  }

  .wrapper {
    align-self: flex-end;
    display: flex;

    .MuiToggleButtonGroup-root {
      margin-right: 25px;
    }
  }

  .clear-button {
    align-self: flex-end;

    button {
      width: 97px;
    }

    svg {
      margin-right: 7px;
      min-width: 14px;
    }

    & > div {
      background: ${props => props.theme.colors.primary};
      position: relative;
      padding-left: 40px;

      svg {
        position: absolute;
        height: 100%;
        width: 14px;
        fill: ${props => props.theme.colors.white};
        font-size: 18px;
        font-weight: 100;
        left: 20px;
        top: 0;

        &.rotate {
          transform: rotate(45deg);
        }
      }
    }
  }

  .react-tags__search input {
    max-width: 200px;
  }
`
